import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/common/Logo";

// Google sign-in is temporarily disabled. Flip to true to re-enable the
// "Continue with Google" buttons on Login/Register (backend route is intact).
export const GOOGLE_AUTH_ENABLED = false;

// Shared shell for auth pages (login / register / reset).
export const AuthShell = ({ title, subtitle, children, footer }) => (
  <div className="flex min-h-screen flex-col bg-background">
    <div className="mx-auto flex w-full max-w-md flex-1 flex-col justify-center px-4 py-12">
      <div className="mb-8 flex justify-center">
        <Logo size={40} />
      </div>
      <div className="rounded-2xl border border-border bg-card p-6 shadow-[0_8px_24px_rgba(16,24,40,0.06)] sm:p-8">
        <h1 className="text-2xl font-[680] tracking-[-0.01em] text-foreground">{title}</h1>
        {subtitle && <p className="mt-1.5 text-sm text-muted-foreground">{subtitle}</p>}
        <div className="mt-6">{children}</div>
      </div>
      {footer && <div className="mt-6 text-center text-sm text-muted-foreground">{footer}</div>}
      <div className="mt-6 text-center">
        <Link to="/" className="text-xs text-muted-foreground hover:text-primary">← Back to home</Link>
      </div>
    </div>
  </div>
);

export const GoogleButton = ({ label = "Continue with Google" }) => {
  const onClick = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid="auth-google-button"
      className="inline-flex h-10 w-full items-center justify-center gap-2 rounded-lg border border-border bg-card text-sm font-[540] text-foreground transition-colors hover:bg-secondary"
    >
      <svg className="h-4 w-4" viewBox="0 0 24 24"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.27-4.74 3.27-8.1z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84A11 11 0 0 0 12 23z"/><path fill="#FBBC05" d="M5.84 14.1a6.6 6.6 0 0 1 0-4.2V7.06H2.18a11 11 0 0 0 0 9.88l3.66-2.84z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1A11 11 0 0 0 2.18 7.06l3.66 2.84C6.71 7.31 9.14 5.38 12 5.38z"/></svg>
      {label}
    </button>
  );
};
